export const roadMapCommonDataArabic = {
    mainHeading: "خارطة طريقنا الموثوقة لضمان نجاحك",
    sectionDescription: "بصفتنا مزودًا رائدًا لخدمات ضمان الجودة، نتبع خارطة طريق منظمة لضمان أعلى جودة للبرامج. من التقييم الأولي إلى الدعم المستمر، يتوافق نهجنا المنهجي مع أهداف عملك، ويضمن اختبارًا قويًا، ويدفع التحسين المستمر.",

    roadMapHeading0: "الاكتشاف والتخطيط",
    roadMapDescription0: "بصفتنا مزودًا رائدًا لخدمات تطوير الذكاء الاصطناعي، نتبع نهجًا منهجيًا يضمن التوافق مع أهداف عملك، ويوفر حلولًا عالية الجودة، ويوفر تحسينًا مستمرًا.",

    roadMapHeading1: "التصميم وإثبات المفهوم",
    roadMapDescription1: "نقوم بتصميم بنية الحل وتطوير إثبات المفهوم، والتحقق من صحة الأفكار لضمان الجدوى والتوافق مع رؤيتك.",

    roadMapHeading2: "التطوير والاختبار",
    roadMapDescription2: "نقدم حلولًا قوية من خلال التطوير السلس والاختبار الدقيق والصيانة المستمرة لتحقيق الأداء الأمثل.",

    roadMapHeading3: "التنفيذ والدعم",
    roadMapDescription3: "أخيرًا، نقوم بتنفيذ الحلول لضمان انتقال سلس، ونقدم صيانة مستمرة للحفاظ على الحل الخاص بك مُحسّنًا ومُحدثًا.",
}